const MAX_MIND_IMAGE_URLS = 10;

export function isFilled(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0;
}

export function filledString(value: unknown): string | null {
  return isFilled(value) ? value.trim() : null;
}

export function filledUrls(value: unknown): string[] | null {
  const items = parseUrlItems(value);
  if (!items) {
    return null;
  }

  const urls = items
    .filter(isFilled)
    .map(url => url.trim())
    .slice(0, MAX_MIND_IMAGE_URLS);

  return urls.length > 0 ? urls : null;
}

export function resolveMindCatalogImageUrls(
  hasMindCatalog: boolean,
  urls: unknown
): string[] | null {
  if (!hasMindCatalog) {
    return null;
  }
  return filledUrls(urls);
}

export function applyMindCatalogImageAt<T extends { imageUrl: string }>(
  product: T,
  urls: string[] | null | undefined,
  index: number
): T {
  if (!urls?.length || index < 0) {
    return product;
  }
  return { ...product, imageUrl: urls[index % urls.length] };
}

export function applyMindCatalogImages<T extends { imageUrl: string }>(
  products: T[],
  urls: string[] | null | undefined
): T[] {
  if (!urls?.length || !products?.length) {
    return products;
  }

  return products.map((product, index) =>
    applyMindCatalogImageAt(product, urls, index)
  );
}

function parseUrlItems(value: unknown): unknown[] | null {
  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value !== 'string' || !value.trim()) {
    return null;
  }

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}
